<template>
    <div id="secure">
        <router-view @authenticated="setAuthenticated" />
        <div>
        </div>
        <h1>Secure Area</h1>
        <p>
            This is a secure area
        </p>
    </div>
</template>

<script>
    export default {
        name: "securePage",
        components: {
        },
        props: ['mockAccount'],
        data() {
            return {
                authenticated: true,
            }
        },
        beforeCreate() {
            this.setAuthenticated();
        },
        mounted() {
            if (!this.authenticated) {
                this.$router.replace({name: "adminPage"});
            }
        },
        methods: {
            setAuthenticated(status) {
                this.authenticated = status;
            },
        },
    }
</script>

<style scoped>
    #secure {
        background-color: #FFFFFF;
        border: 1px solid #CCCCCC;
        padding: 20px;
        margin-top: 10px;
    }
</style>